import { ConditionEvaluatorBase } from './condition-evaluator.base';

export class EqualConditionEvaluator extends ConditionEvaluatorBase {
  public override evaluate(): boolean {
    return this.control.value === this.value;
  }
}
